import _ from 'lodash'
import { globalPreventRules }  from 'scoreboard/components/paste/default-paste-allowed'
import FormType from './model/form-type'
const { FORM, PAGE, FOLDER, DIALOG, NAVIGATION_TABS } = FormType
import getParentForm from './get-parent-form'

const debug = false

function log(msg) {
	if (debug) console.log(msg)
}

/**
 * Factory that returns the formsPasteAllowed function.  We do it this way so
 * that we can capture some required information in a closure.
 *
 * NOTE: please leave log statements in place because it's not possible
 * to debug this with the debugger when using drag and drop in the browser
 *
 * @param {treeCallback} getTree returns the tree
 */
function formsPasteAllowedFactory(getTree) {

	/**
	 * Returns whether a paste is allowed for forms
	 * @param item the node to be pasted
	 * @param parent the new parent for the node (null if pasting to the top level)
	 * @param empty true if the org is empty
	 * @param mode either 'copy' or 'move'
	 * @param org the org the destination paste occurs in
	 */
	function formsPasteAllowed(item, parent, empty, mode, org) {
		if (globalPreventRules.apply(this, arguments)) {
			return false
		}

		// Top level can be a form or a folder
		if (_.isNil(parent)) {
			log('top level rule triggered')
			return item.type === FORM || item.type === FOLDER
		}

		// Forms and folders can be under folders
		if (parent.type === FOLDER) {
			log('rules for parent=folder')
			return item.type === FORM || item.type === FOLDER
		}

		// Only pages can be under navigation tabs
		if (parent.type === NAVIGATION_TABS) {
			let tree = getTree()
			let itemFormId = getParentForm(tree, item.id)?.id
			let parentFormId = getParentForm(tree, parent.id)?.id
			let canMove = item.type === PAGE &&
				// #34961 can't move pages into different forms
				itemFormId == parentFormId
			log('rules for parent=navigation tabs triggered')
			log('itemRootId: ' + itemFormId)
			log('parentRootId: ' + parentFormId)
			log('canMove: ' + canMove)
			return canMove
		}

		// Pages, navigation tabs, and dialogs can be under forms
		if (parent.type === FORM) {
			log('rules for parent=form triggered')
			let tree = getTree()
			// #60069
			// beforeDragState is passed in through `_isIllegal` from the
			// `dnd.js` file of kalpa-tree rather than already being tied to the
			// tree node. Set this here to allow the expected behavior.
			const treeNode = tree.get(item.id)
			if (treeNode) {
				treeNode.beforeDragState = {
					parentId: item.beforeDragState?.parent ?? null
				}
			}
			let oldParentFormId = getParentForm(tree, item.id)?.id
			let newParentFormId = getParentForm(tree, parent.id)?.id
			let canMove = [PAGE, NAVIGATION_TABS, DIALOG].includes(item.type) &&
				// #34961 can't move pages, navigation tabs, and dialogs into
				// different forms
				oldParentFormId == newParentFormId
			log('canMove: ' + canMove)
			return canMove
		}

		// nothing is allowed under pages or dialogs
		if (parent.type === PAGE || parent.type === DIALOG) {
			log('nothing is allowed under pages or dialogs')
			return false
		}

		log('no other rules triggered, so returning false')
		return false
	}

	return formsPasteAllowed
}

export default formsPasteAllowedFactory

formsPasteAllowedFactory.__filename__ = 'forms/forms-paste-allowed-factory.js'
